import { HeadCell } from "../../components/common/SortableTableHead";

export const COLUMN_HEADERS: HeadCell[] = [
    { label: "Hardware Source", property: "hardwareSource", sortable: true },
    { label: "FNSKU", property: "fnsku", sortable: false },
    { label: "Compute Timestamp", property: "computeTimestamp", sortable: true },
    { label: "Affinity Threshold", property: "affinityThreshold", sortable: true },
    { label: "Capture Image Threshold", property: "captureImageThreshold", sortable: false },
    { label: "Metadata", property: "metadataLocation", sortable: false },
];

export const INITIAL_MESSAGE: string = "Please search for an item to view results";

export const EMPTY_RESULTS_MESSAGE: string = "No captures available for requested item in Canonical Representation repository";

export const ERROR_MESSAGE_RETRIEVE_METADATA: string = "Something went wrong while retrieving Metadata";

export const ERROR_MESSAGE_RETRIEVE_CANONICAL_REPRESENTATION_DATA: string = 
    "Something went wrong while retrieving canonical representation data for requested item"
